import styled from 'styled-components';

interface IAberto {
  $aberto: boolean;
}

export const Fundo = styled.div<IAberto>`
  position: fixed;
  inset: 0;
  background-color: ${({ theme }) => theme.cores.overlay};
  opacity: ${({ $aberto }) => ($aberto ? 1 : 0)};
  visibility: ${({ $aberto }) => ($aberto ? 'visible' : 'hidden')};
  transition: opacity 0.25s ease, visibility 0.25s ease;
  z-index: ${({ theme }) => theme.zIndex.drawer};
`;

export const Gaveta = styled.nav<IAberto>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: min(85vw, 320px);
  background-color: ${({ theme }) => theme.cores.primary};
  color: ${({ theme }) => theme.cores.inkInverse};
  transform: ${({ $aberto }) => ($aberto ? 'translateX(0)' : 'translateX(-100%)')};
  visibility: ${({ $aberto }) => ($aberto ? 'visible' : 'hidden')};
  transition: transform 0.25s ease, visibility 0.25s ease;
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  box-shadow: ${({ theme }) => theme.sombra.modal};
`;

export const Topo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.espaco.sm};
  padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.sm} ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.lg};
  border-bottom: 1px solid ${({ theme }) => theme.cores.borderInverse};
`;

export const Rolagem = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${({ theme }) => theme.espaco.sm};
  overscroll-behavior: contain;
`;

export const Secao = styled.div`
  & + & {
    margin-top: ${({ theme }) => theme.espaco.md};
    padding-top: ${({ theme }) => theme.espaco.md};
    border-top: 1px solid ${({ theme }) => theme.cores.borderInverse};
  }
`;

export const TituloSecao = styled.h2`
  padding: ${({ theme }) => theme.espaco.xs} ${({ theme }) => theme.espaco.md};
  color: ${({ theme }) => theme.cores.inkInverseMuted};
  font-size: ${({ theme }) => theme.fonte.caption};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const Item = styled.button<{ $nivel: number; $ativo?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
  min-height: 44px;
  padding: 0 ${({ theme }) => theme.espaco.md} 0 ${({ $nivel }) => 12 + $nivel * 20}px;
  border: none;
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ $ativo, theme }) => ($ativo ? theme.cores.primarySoft : 'transparent')};
  box-shadow: ${({ $ativo, theme }) => ($ativo ? `inset 3px 0 0 ${theme.cores.accent}` : 'none')};
  color: ${({ $ativo, theme }) => ($ativo ? theme.cores.accent : theme.cores.inkInverse)};
  font-size: ${({ theme }) => theme.fonte.input};
  text-align: left;

  span {
    flex: 1;
  }

  &:active,
  &:hover {
    background-color: ${({ theme }) => theme.cores.primarySoft};
  }

  .seta {
    transition: transform 0.2s ease;
  }

  &[aria-expanded='true'] .seta {
    transform: rotate(180deg);
  }
`;

export const SubMenu = styled.div<IAberto>`
  display: ${({ $aberto }) => ($aberto ? 'block' : 'none')};
`;

export const Rodape = styled.div`
  padding: ${({ theme }) => theme.espaco.sm};
  border-top: 1px solid ${({ theme }) => theme.cores.borderInverse};
`;
